import * as React from "react"
import RandomPersonnelIdentifier from "../../api/Randoms/RandomPersonnelModel/RandomPersonnelIdentifier"
import Checkbox from "../Checkbox"

export interface RandomPersonnelCheckboxProps {
  id: string
  person: RandomPersonnelIdentifier
  checked: boolean
  onChange: (person: RandomPersonnelIdentifier, checked: boolean) => void
}

export default class RandomPersonnelCheckbox extends React.PureComponent<RandomPersonnelCheckboxProps> {
  onChange = (e: React.ChangeEvent<HTMLInputElement>) => this.props.onChange(this.props.person, e.target.checked)
  render() { return <Checkbox checked={this.props.checked} onChange={this.onChange} id={this.props.id}/>}
}
